import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  header: {
    background: "#E8E8E8",
    display: "flex",
    alignItems: "center",
    height: "49px",
    padding: "0px 0px 0 15px",
    "& h1": {
      padding: "0px 15px",
      fontSize: "22px",
      fontWeight: 600,
      lineHeight: "28.8px",
      color: "#2D4D95",
    },
  },
  gridHeader: {
    padding: "6px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .HeaderDialog": {
      display: "flex",
      alignItems: "center",
      justifyContent: "right",
    },
  },
  gridActions: {
    textAlign: "right",
  },
  GridHeading: {
    color: "var(--accent-colors-ui-1-default, #3C4549)",
    fontFamily: "Lato",
    fontSize: "19.819px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  },

  changeBtn: {
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    backgroundColor: "#454545",
    borderRadius: "6px",
    marginRight: "5px",
    padding: "8px 16px",
    textTransform: "capitalize",
    cursor: "pointer",
    color: "#ffffff",
    boxShadow:
      "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
    "&:hover": {
      color: "#ffffff",
      background: "#5e5e5e",
    },
  },
  profileNavigationIco: {
    maxWidth: '20px',
    padding: '2px',
},

  Card: {
    height: "460px",
    borderRadius: "10px",
    border: "1px solid #D9D9D9",
    display: "flex",
    padding: "10px",
    flexDirection: "column",
    alignItems: "center",
    gap: "19px",
    margin: "8px",
    cursor: 'pointer',

    "& .CardMain": {
      cursor: 'pointer',
      textAlign: "center",
    },
    "& .CardBanner": {
      position: "relative",
      width: '100%',
      height: '240px',
      maxHeight: '240px',
      minHeight: '240px',

    },
    "& .BannerImg": {
      borderRadius: "10px",
      height: '240px',
      maxHeight: '240px',
      minHeight: '240px',
      objectFit: 'cover !important',
    },
    "& img": {
      width: "100%",
      maxWidth: "100%",
      marginRight: "0",

    },
    "& .DetailLogo": {
      maxWidth: "24px",
      minWidth: "40px",
      maxHeight: "24px",
      position: "absolute",
      right: "0",
      top: "5px",
    },
    "& .CardHeading": {
      
      fontFamily: "Lato",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHight: "16px;",
      letterSpacing: "0.24px",
      marginBottom: "20px",
      transition: theme.transitions.create('all', {
        duration: 500,
        easing: theme.transitions.easing.easeIn,
      }),

      '&:hover': {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '25px',
      },
    },
    "& .CardBody": {
      color: '#424242',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    maxWidth: '100%',


      textAlign: "center",
      fontFamily: "Lato",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "16px",
      letterSpacing: "0.14px",
      marginBottom: "20px",
    },
    "& .CardLogo": {
      width: "137px",
      minWidth: "137px",
      height: "35.773px",
      marginBottom: "20px",
    },
  },
  profileDropper: {
    margin: '8px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    "& h4": {
        margin: 0,
        padding: '10px',
        color: '#0049A3',
        fontSize: '15px',
        lineHeight: '16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        '@media (max-width: 550px)': {
            display: 'none',
        },
    },
    "& :hover": {
        backgroundColor: 'none !important',
    },
    "& svg": {
        color: '#0049A3',
    }
  
  },
  Container: {
    padding: "12px",
  },
  NoRecord: {
    height: '200px',
    width: '100%',
    background: 'white',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  
}));
